<template>
  <div
    title="Сменить расположение меню"
    class="d-flex align-items-center"
  >
    <b-form-checkbox
      v-model="verticalLayoutEnabled"
      name="is-vertical-menu-collapsed"
      class="mr-25"
      switch
      inline
      @change="onChangeLayout"
    ></b-form-checkbox>
    <span @click="onChangeLayout">Вертикальное меню</span>
  </div>
</template>

<script>
import store from '@/store'
import useAppCustomizer from '@/core/layouts/components/app-customizer/useAppCustomizer'
import useAppConfig from '@/core/app-config/useAppConfig'
import { ref } from 'vue'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'LayoutTypeSwitcher',
  components: {
    BFormCheckbox
  },
  setup() {
    const { layoutTypeOptions } = useAppCustomizer()
    const { layoutType, layoutTypeIsVertical } = useAppConfig()
    const verticalLayoutEnabled = ref(layoutTypeIsVertical.value)

    const onChangeLayout = () => {
      const index = layoutTypeOptions.findIndex(i => i.value !== layoutType.value)
      if (index > -1) {
        store.commit('appConfig/UPDATE_LAYOUT_TYPE', layoutTypeOptions[index].value)
      }
    }
    return { verticalLayoutEnabled, onChangeLayout }
  },
}
</script>

<style lang='scss'></style>
